// extracted by mini-css-extract-plugin
export default {"breakpointxs":"0","label":"Label_label__ElA-0","error":"Label_error__67Ppy","label-sm":"Label_label-sm__gPjNw","label-md":"Label_label-md__Gq7Wl","label-lg":"Label_label-lg__W80Cw"};